var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "map_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 15,
    viewBox: "2 1 18 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5622",
    "data-name": "Path 5622",
    d: "M0,0H18V18H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5623",
    "data-name": "Path 5623",
    d: "M11.737,4.514,7.987,3.2a1.5,1.5,0,0,0-.975-.008L4.02,4.2A1.51,1.51,0,0,0,3,5.624v8.888a1.5,1.5,0,0,0,2.04,1.4l2.2-.855a.724.724,0,0,1,.517-.008l3.75,1.313a1.5,1.5,0,0,0,.975.007l2.993-1a1.5,1.5,0,0,0,1.02-1.425V5.047a1.5,1.5,0,0,0-2.04-1.4l-2.2.855a.766.766,0,0,1-.517.007ZM12,14.947,7.5,13.364V4.612L12,6.194Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapBlack);
export default __webpack_public_path__ + "static/media/mapBlack.24be4bb84ed1290ade24e6bc8802b796.svg";
export { ForwardRef as ReactComponent };